import React, { Component } from 'react';
import classNames from 'classnames';
import Population from './detail-components/population';
import PurchasingPower from './detail-components/purchasing-power';
import Origin from './detail-components/origin';
import Household from './detail-components/household';
import Education from './detail-components/education';
import Demographics from './detail-components/demographics';
import SpinnerDots from '../spinner/dots';
import withAuthProvider from '../../hoc/withAuthProvider';
import { REACT_APP_API_BASE } from '../../config';
import './scb-stats.scss';

class ScbStats extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
            stats: null,
            isLoading: false,
            noSelection: true
        };

        this.controller = null;
    }

    async fetchScbStats({
        aregion,
        county,
        localities,
        municipality,
        parish,
        postalCodes }) {
        
        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        
        if (this.controller) {
            this.controller.abort();
        }

        this.controller = new AbortController();
        const { signal } = this.controller;
        
        const path = `${REACT_APP_API_BASE}/salesdistrict/scbdata`;
        try {
            const rawResponse = await fetch(path, {
                signal,
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    aregion,
                    county,
                    localities,
                    municipality,
                    parish,
                    postalCodes
                })
            });
        
            if (rawResponse.ok) {
                const stats = await rawResponse.json();
                return {
                    scbReportData: stats.scbReportData,
                    isLoading: false
                }
            }
        } catch(e) {
            return {
                scbReportData:this.state.stats,
                isLoading: true
            };
        }
    }

    async componentDidUpdate(prevProps) {
        if (this.props.layerSelection !== prevProps.layerSelection || (this.props.layerSelection && this.props.isOpen && this.props.isOpen !== prevProps.isOpen)) {
            const {
                aregion,
                county,
                localities,
                municipality,
                postalCodes } = this.props.layerSelection;

            this.setState({
                isLoading: true
            });

            const scbStats = await this.fetchScbStats(this.props.layerSelection);
            
            if (!scbStats) return;

            this.setState({
                stats: scbStats.scbReportData,
                isLoading: scbStats.isLoading,
                noSelection: aregion.length === 0 && 
                             county.length === 0 && 
                             localities.length === 0 && 
                             municipality.length === 0 && 
                             postalCodes.length === 0
            });   
        }
    }

    togglelTab(activeTab) {
        this.setState({
            activeTab
        });
    }
    
    render() {

        if (!this.props.isOpen) return null;

        return (
            <div className={classNames({
                'scb-stats': true,
                'scb-stats--is-loading': this.state.isLoading
            })}>
                <header className="scb-stats__header">
                    <ul className="scb-stats__tabs">
                        <li>
                            <button type="button" 
                                    className={classNames({
                                        'scb-stats__tabs-item': true,
                                        'scb-stats__tabs-item--selected': this.state.activeTab === 1
                                    })} 
                                    onClick={() => this.togglelTab(1)}>Befolkning</button>
                        </li>
                        <li>
                            <button type="button" 
                                    className={classNames({
                                        'scb-stats__tabs-item': true,
                                        'scb-stats__tabs-item--selected': this.state.activeTab === 2
                                    })} 
                                    onClick={() => this.togglelTab(2)}>Köpkraft</button>
                        </li>
                        <li>
                            <button type="button" 
                                    className={classNames({
                                        'scb-stats__tabs-item': true,
                                        'scb-stats__tabs-item--selected': this.state.activeTab === 3
                                    })} 
                                    onClick={() => this.togglelTab(3)}>Ursprung</button>
                        </li>
                        <li>
                            <button type="button" 
                                    className={classNames({
                                        'scb-stats__tabs-item': true,
                                        'scb-stats__tabs-item--selected': this.state.activeTab === 4
                                    })} 
                                    onClick={() => this.togglelTab(4)}>Hushåll</button>
                        </li>
                        <li>
                            <button type="button" 
                                    className={classNames({
                                        'scb-stats__tabs-item': true,
                                        'scb-stats__tabs-item--selected': this.state.activeTab === 5
                                    })} 
                                    onClick={() => this.togglelTab(5)}>Utbildning</button>
                        </li>
                    </ul>
                </header>
                
                <div className="scb-stats__content">
                    {!this.state.noSelection && this.state.stats && 
                        <div className="scb-stats__content-inner">
                            {this.state.activeTab === 1 &&
                                <div className="scb-stats__tab">
                                    <Demographics demographics={this.state.stats.populationByGenderDataset}
                                                  smallLabel={true}
                                                  modifiers={{
                                                    'demographics--small': true }} />                                
                                    <Population data={this.state.stats.populationByAgeDataset} 
                                                height={210} 
                                                heading="Åldersfördelning"
                                                modifiers={{
                                                    'scb-stats__graph': true }} />
                                </div>
                            }
                            {this.state.activeTab === 2 &&
                                <div className="scb-stats__tab">
                                    <PurchasingPower data={this.state.stats.populationByEconomicStandardDataset} 
                                                    height={210}
                                                    modifiers={{
                                                        'scb-stats__graph': true
                                                    }} />
                                </div>
                            }
                            {this.state.activeTab === 3 &&
                                <div className="scb-stats__tab">
                                    <Origin data={this.state.stats.populationByOriginDataset} 
                                            height={210}
                                            modifiers={{
                                                'scb-stats__graph': true
                                            }} />
                                </div>
                            }
                            {this.state.activeTab === 4 &&
                                <div className="scb-stats__tab">
                                    <Household data={this.state.stats.houseHoldTypesDataset} 
                                            height={210}
                                            modifiers={{
                                                'scb-stats__graph': true
                                            }} />
                                </div>
                            }
                            {this.state.activeTab === 5 &&
                                <div className="scb-stats__tab">
                                    <Education data={this.state.stats.populationByEducationDataset} 
                                            height={210}
                                            modifiers={{
                                                'scb-stats__graph': true
                                            }} />
                                </div>
                            }
                        </div>   
                    }
                    {this.state.noSelection && !this.state.isLoading &&
                        <div className="scb-stats__no-selection">
                            <p>Välj ett område för att se statistik</p>    
                        </div>
                    }
                    <SpinnerDots />
                </div>
            </div>
        );
    }
};

export default withAuthProvider(ScbStats);